import { Modal, Button } from 'rsuite';

export default function DelConfirmDialog(props) {
  const { isOpen, onConfirm, onCancel, data } = props;

  return (
      <Modal open={isOpen} onClose={onCancel}>
        <Modal.Header>
          <Modal.Title>Confirmar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>¿Eliminar el usuario {data.nombre}?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onConfirm(data.id)} appearance="primary" color={'red'}>
            Eliminar
          </Button>
          <Button onClick={onCancel} appearance="subtle">
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
  );
};
